import React from 'react';

import { ComboboxOption } from '@lumapps/combobox/components/ComboboxOption';
import { mdiClockOutline } from '@lumapps/lumx/icons';
import { Icon, Size } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { QUICK_SEARCH } from '../../keys';
import { SearchBoxOptionTypeProps } from '../../types';
import { SearchBoxOptionLabel } from '../SearchBoxOptionLabel';

/**
 * Component to display a "history" type option
 * These option have a specific icon and redirects to the search page.
 */
export const SearchHistoryOption = ({ suggestion, historyOptions, ...forwardedProps }: SearchBoxOptionTypeProps) => {
    const { translateKey } = useTranslate();

    const SuggestionIcon = (
        <Icon
            alt={translateKey(QUICK_SEARCH.HISTORY_ITEM)}
            icon={historyOptions?.icon ?? mdiClockOutline}
            hasShape={historyOptions?.hasShape ?? false}
            size={Size.s}
            color={historyOptions?.color}
        />
    );

    return (
        <ComboboxOption textValue={suggestion.label} before={SuggestionIcon} data={suggestion} {...forwardedProps}>
            <SearchBoxOptionLabel label={suggestion.label} />
        </ComboboxOption>
    );
};
